export class LocalizedValue {

  constructor(public id: number, public langCode: string, public value: string) {}

  static copyArray (localizedValues: LocalizedValue[]): LocalizedValue[] {
    const lvs: LocalizedValue[] = [];
    for (const lv of localizedValues) {
      lvs.push(lv.copy());
    }
    return lvs;
  }

  copy(): LocalizedValue {
    return new LocalizedValue(null, this.langCode, this.value);
  }
}
